import React from 'react';
import ArtisanProductGrid from './artisanProductGrid';

const ArtisanViewListings = ({ products }) => {
  // Assume products is an array of product objects
  console.log('products 6 artisanviewlisting',products)
  return (
    <div>
      <h1>My Listings</h1>
      
      <ArtisanProductGrid products={products} />
      {/* Add options to edit or delete listings */}
    </div>
  );
};

export default ArtisanViewListings;
